import { PlanningProgress } from "@providers/hop-ord-server/api";

export type AutomationStatus =
  | "success"
  | "warning"
  | "error"
  | "in_progress"
  | "not_started";

export const getElapsedTimeSubtext = (status: AutomationStatus): string => {
  switch (status) {
    case "success":
      return "Completed | Elapsed time:";
    case "error":
      return "Failed | Elapsed time:";
    case "not_started":
      return "Queued";
    default:
      return "Processing | Elapsed time:";
  }
};

export const getPlanProgressPercentage = (
  stepSequence: string[],
  step: string,
) => {
  const stepIndex = stepSequence.indexOf(step);
  if (stepIndex === -1) {
    return 0;
  }
  return ((stepIndex + 1) / stepSequence.length) * 100;
};

export const getStatusColour = (status: AutomationStatus) => {
  if (status === "success") {
    return "success";
  }

  if (status === "error") {
    return "error";
  }

  if (status === "in_progress") {
    return "secondary";
  }

  return "inherit";
};

export const getAutomationStatus = (
  progress?: PlanningProgress,
): AutomationStatus => {
  if (progress?.result?.success) {
    return "success";
  }
  if (progress?.result?.error) {
    return "error";
  }
  if (progress?.planningStartedAt) {
    return "in_progress";
  }
  return "not_started";
};
